import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
};

const defaultProps = {
    className: null,
    color: '#ff0053',
};

const AsteriskIcon = ({ color, className }) => (
    <svg id="b" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.09 26.42" className={className}>
        <g id="c">
            <path
                d="m12.85,7.65c.28.59.61.99,1.01,1.22.39.22.81.23,1.24.03.35-.17.68-.49.98-.97L20.91.94l2.15,1.5-4.78,6.95c-.52.82-.66,1.49-.42,2,.28.59.88.9,1.82.94l8.4.7-.2,2.62-8.46-.67c-.56-.07-1.02-.02-1.37.15-.43.2-.69.53-.76.97-.08.44.02.96.3,1.55l3.63,7.65-2.35,1.12-3.63-7.65c-.28-.59-.62-.99-1.01-1.22-.39-.22-.81-.23-1.24-.03-.35.17-.68.49-.98.97l-4.84,6.98-2.15-1.5,4.83-6.98c.54-.79.68-1.45.42-2-.22-.47-.83-.79-1.82-.94l-8.46-.67.2-2.62,8.46.67c.56.07,1.02.02,1.37-.15.43-.2.69-.53.76-.97.08-.45-.02-.96-.3-1.55L6.87,1.12l2.35-1.12,3.63,7.65Z"
                fill={color}
            />
        </g>
    </svg>
);

AsteriskIcon.propTypes = propTypes;
AsteriskIcon.defaultProps = defaultProps;

export default AsteriskIcon;
